import jwtDecode from "jwt-decode";
import {getCookie } from '@/commonContent/js/Cookie'
export const GetTokeUserInfo = () => {
  return jwtDecode(getCookie("token"));
}
